import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-auto flex-grow-0 d-flex justify-content-between align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, " Выберите технику ", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-auto d-none d-sm-block flex-grow-1" })
  ])
], -1)
const _hoisted_6 = { class: "overflow-hidden" }
const _hoisted_7 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"650px"}
}

import api from "@/api";
import { reactive, computed, watch } from "vue";
import formatMoney from "@/utils/formatMoney";
import { ISectionJob, constructiveReportType, materialType } from "@/@types/ISectionJob";
import CalculationReportTableComponent from './CalculationReportTableComponent.vue';

type reportStateType = {
    endedSectionJobs: ISectionJob[];
    sectionJobId: number;
    constructives: constructiveReportType[];
    materials: materialType[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CalculationReportComponent',
  setup(__props) {


const state: reportStateType = reactive({
    endedSectionJobs: [],
    sectionJobId: 0,
    constructives: [],
    materials: [],
});

api.sectionJob.getEndedSectionJobsList().then(r => {
    state.endedSectionJobs = r.data;
});

watch(() => [state.sectionJobId], (v: any) => {
    if (!state.sectionJobId) {
        return;
    }
    api.sectionJob.getCalculationReport(state.sectionJobId).then(r => {
        state.constructives = r.data.constructives;
        state.materials = r.data.materials;
    })
})

const constructiveTotals = computed(() => {
    return state.constructives.reduce((acc, constructive) => {
        acc.hoursWorked += constructive.hoursWorked;
        acc.total += constructive.total;
        return acc;
    }, {
        hoursWorked: 0,
        total: 0,
    });
});

const materialTotals = computed(() => {
    return state.materials.reduce((acc, material) => {
        acc.count += Number(material.count);
        acc.total += Number(material.total);
        return acc;
    }, {
        count: 0,
        total: 0,
    });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.sectionJobId) = $event)),
        class: "form-select"
      }, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.endedSectionJobs, (sectionJob) => {
          return (_openBlock(), _createElementBlock("option", {
            key: sectionJob.id,
            value: sectionJob.id
          }, _toDisplayString(sectionJob.name), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, state.sectionJobId]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(CalculationReportTableComponent, {
            constructives: state.constructives,
            materials: state.materials
          }, null, 8, ["constructives", "materials"])
        ])
      ])
    ])
  ], 64))
}
}

})